var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205 4982 c-62 -21 -114 -60 -150 -111 -59 -85 -55 72 -55 -2455 0 -2284 0 -2322 20 -2353 50 -82 160 -82 210 0 20 31 20 63 20 1609 l0 1578 2268 2 2267 3 42 23 c66 35 110 79 140 140 l28 57 0 650 0 650 -28 57 c-32 64 -80 111 -146 142 l-46 21 -2260 2 c-2123 2 -2263 1 -2310 -15z m4529 -248 c14 -14 16 -83 16 -609 0 -526 -2 -595 -16 -609 -14 -14 -230 -16 -2234 -16 -2004 0 -2220 2 -2234 16 -14 14 -16 83 -16 609 0 526 2 595 16 609 14 14 230 16 2234 16 2004 0 2220 -2 2234 -16z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.79c11797.svg";
export { ForwardRef as ReactComponent };